import QBWebhooksComponent from './qb-webhooks.component';

const DEPENDENCIES = [];

let moduleName = 'ais.qb-webhooks';

try {
  angular.module( moduleName );
  console.error( `Angular module '${ moduleName }' has already been created elsewhere. Aborting this creation attempt.` );
}
catch( err ) {
  angular
    .module(moduleName, DEPENDENCIES)
    .component('qbWebhooks', QBWebhooksComponent)
}
